@if (message) {
  <div class="estimate-notice-wrap">
    <div class="estimate-notice">
      <p>{{ message | translate }}</p>
    </div>
  </div>
}
